module.exports = __webpack_public_path__ + "img/logo.5aac2d52.png";